/* Raíz Activa · interacción de las fichas au-* */
(function () {
  /* menú de la cabecera */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-au-menu]')) { var n = document.querySelector('[data-au-nav]'); if (n) n.classList.toggle('open'); return; }
    var nv = e.target.closest('[data-au-nav]'); if (nv && e.target === nv) nv.classList.remove('open');
  });

  /* galería: miniaturas (escritorio) ↔ deslizable */
  document.querySelectorAll('[data-au-gal]').forEach(function (g) {
    var tr = g.querySelector('.au-gal__tr'), th = g.querySelectorAll('.au-gal__th button');
    var step = function () { var s = tr.querySelector('.au-gal__s'); return s ? s.getBoundingClientRect().width + 12 : tr.clientWidth; };
    th.forEach(function (b) { b.addEventListener('click', function () { tr.scrollTo({ left: step() * +b.dataset.i, behavior: 'smooth' }); }); });
    tr.addEventListener('scroll', function () { var i = Math.round(tr.scrollLeft / step()); th.forEach(function (b, k) { b.classList.toggle('on', k === i); if (k === i && b.parentNode.scrollWidth > b.parentNode.clientWidth) { b.parentNode.scrollTo({ left: b.offsetLeft - b.parentNode.offsetLeft - 20, behavior: 'smooth' }); } }); }, { passive: true });
  });

  document.querySelectorAll('[data-au-main]').forEach(function (m) {
    /* packs: variante y precio del botón */
    var id = m.querySelector('[data-au-id]'), pr = m.querySelector('[data-au-price]'), sub = m.querySelector('[data-au-sub]'), spi = m.querySelector('[data-au-sp]');
    var updSub = function () {
      var r = m.querySelector('input[name=au_var]:checked'); if (!r) return; id.value = r.value;
      var on = sub && sub.checked && r.dataset.subPrice; if (spi) spi.disabled = !on;
      if (pr) pr.textContent = on ? r.dataset.subPrice : r.dataset.price;
      /* tarjetas de packs: con suscripción, precio tachado + precio con descuento */
      var subOn = sub && sub.checked;
      /* regalos: se desbloquean según la posición del pack elegido (1, 2, 3) */
      var radios = [].slice.call(m.querySelectorAll('input[name=au_var]')), pos = radios.indexOf(r) + 1;
      var gn = 0, gt = 0;
      m.querySelectorAll('.au-gf__i').forEach(function (g) { var u = pos >= (+g.dataset.from || 1); g.classList.toggle('on', u); gt++; if (u) gn++; });
      var gc = m.querySelector('[data-au-gcount]'), gb = m.querySelector('[data-au-gbar]');
      if (gc) gc.textContent = gn; var gtt = m.querySelector('[data-au-gtotal]'); if (gtt) gtt.textContent = gt; if (gb) gb.style.width = (gt ? gn / gt * 100 : 0) + '%';
      m.querySelectorAll('input[name=au_var]').forEach(function (x) {
        x.closest('label').querySelectorAll('.au-v__p').forEach(function (p) {
          var was = x.dataset.cmp || x.dataset.price, d = x.dataset;
          if (subOn && d.subPrice) p.innerHTML = '<s class="au-v__was">' + was + '</s> ' + d.subPrice + '<span class="au-v__save">Ahorra ' + d.subSave + '&nbsp;%</span>';
          else if (d.cmp) p.innerHTML = '<s class="au-v__was">' + d.cmp + '</s> ' + d.price + '<span class="au-v__save">Ahorra ' + d.save + '&nbsp;%</span>';
          else p.innerHTML = d.price;
        });
      });
    };
    m.querySelectorAll('input[name=au_var]').forEach(function (r) { r.addEventListener('change', updSub); });
    if (sub) sub.addEventListener('change', updSub); updSub();

    /* regalo físico: desde el pack N se añade gratis al pedido junto con el frasco (y la suscripción si está marcada) */
    var fm = m.querySelector('[data-au-form]');
    if (fm && fm.dataset.giftVariant) fm.addEventListener('submit', function (e) {
      var r = m.querySelector('input[name=au_var]:checked'), radios = [].slice.call(m.querySelectorAll('input[name=au_var]'));
      var pos = r ? radios.indexOf(r) + 1 : 1; if (pos < (+fm.dataset.giftFrom || 2)) return;
      e.preventDefault();
      var main = { id: +id.value, quantity: 1 }; if (spi && !spi.disabled) main.selling_plan = +spi.value;
      var btn = m.querySelector('[data-au-atc]'); if (btn) btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [main, { id: +fm.dataset.giftVariant, quantity: 1, properties: { _regalo: 'abanico' } }] }) })
        .then(function (res) { if (!res.ok) throw 0; location.href = '/checkout'; })
        .catch(function () { if (btn) btn.disabled = false; fm.submit(); });
    });
    /* «llega entre el … y el …»: hoy (hora de Madrid) + días laborables (lun–vie), fechas es-ES */
    var eta = m.querySelector('[data-au-eta]');
    if (eta) {
      var tz = 'Europe/Madrid', p = {}, now = new Date();
      new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
      var base = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12));
      var add = function (k) { var d = new Date(base.getTime()), n = k; while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); var w = d.getUTCDay(); if (w !== 0 && w !== 6) n--; } return d; };
      var fmt = function (d, o) { return d.toLocaleDateString('es-ES', Object.assign({ timeZone: 'UTC' }, o)); };
      var mn = +eta.dataset.min || 1, mx = +eta.dataset.max || mn, d1 = add(mn), d2 = add(mx);
      if (mx > mn) eta.textContent = (d1.getUTCMonth() === d2.getUTCMonth() ? fmt(d1, { weekday: 'short', day: 'numeric' }) : fmt(d1, { weekday: 'short', day: 'numeric', month: 'short' })) + ' y el ' + fmt(d2, { weekday: 'short', day: 'numeric', month: 'short' });
      else eta.textContent = fmt(d1, { weekday: 'long', day: 'numeric', month: 'long' });
    }
    /* barra fija móvil: aparece al pasar el botón de compra */
    var st = document.querySelector('[data-au-sticky]'), atc = m.querySelector('[data-au-atc]');
    if (st && atc) {
      var upd = function () { var r = atc.getBoundingClientRect(); st.classList.toggle('on', r.bottom < 0); };
      addEventListener('scroll', upd, { passive: true }); upd();
      st.querySelector('[data-au-go]').addEventListener('click', function () { m.querySelector('.au-form').scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  });

  /* cuenta atrás hasta la fecha del editor (hora de Madrid); sin fecha = hasta medianoche de Madrid y se reinicia; vencida = oculta */
  var mad = function (d) { var p = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(d).forEach(function (x) { p[x.type] = +x.value; }); return p; };
  var madOff = function (d) { var p = mad(d); return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(d.getTime() / 1000) * 1000; };
  document.querySelectorAll('[data-au-cd]').forEach(function (c) {
    var raw = (c.dataset.end || '').trim(), end;
    if (raw) { var q = raw.match(/(\d+)-(\d+)-(\d+)[ T](\d+):(\d+)/); if (!q) return; var u = Date.UTC(+q[1], +q[2] - 1, +q[3], +q[4], +q[5]); end = new Date(u - madOff(new Date(u))); }
    else { var n = new Date(), p = mad(n); end = new Date(n.getTime() + (86400 - (p.hour * 3600 + p.minute * 60 + p.second)) * 1000); }
    var h = c.querySelector('[data-h]'), mi = c.querySelector('[data-m]'), s = c.querySelector('[data-s]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    (function tick() {
      var t = Math.floor((end - new Date()) / 1000);
      if (t <= 0) { c.hidden = true; return; }
      c.hidden = false;
      h.textContent = pad(Math.floor(t / 3600)); mi.textContent = pad(Math.floor(t % 3600 / 60)); s.textContent = pad(t % 60);
      setTimeout(tick, 1000);
    })();
  });

  /* carrusel de reseñas: barra de progreso */
  document.querySelectorAll('[data-au-rs]').forEach(function (tr) {
    var dots = tr.parentNode.querySelectorAll('[data-au-dots] i');
    tr.addEventListener('scroll', function () {
      var w = tr.querySelector('.au-rv').getBoundingClientRect().width + 12, i = Math.round(tr.scrollLeft / w);
      dots.forEach(function (x, k) { x.classList.toggle('on', k === i); });
    }, { passive: true });
  });

  /* resultados: el % sube desde 0 cuando la sección entra en pantalla (como Auniva) */
  var cnt = document.querySelectorAll('[data-au-count]');
  if (cnt.length) {
    var run = function (el) {
      var to = +el.dataset.auCount || 0, t0 = null;
      (function f(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1800); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))) + '%'; if (k < 1) requestAnimationFrame(f); })(performance.now());
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }); }, { threshold: .5 });
      cnt.forEach(function (el) { io.observe(el); });
    } else cnt.forEach(function (el) { el.textContent = el.dataset.auCount + '%'; });
  }

  /* reseñas: cargar más */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-au-more]'); if (!b) return;
    b.closest('.au-rw').querySelectorAll('.au-rw__i.hid').forEach(function (x) { x.classList.remove('hid'); });
    b.remove();
  });
})();
